import { TableCellEmpty } from '@/components/custom';
import { TableCell } from '@/components/ui';
import { getAge } from '@/functions';
import { IHasUser } from '.';

export const DataTableBodyCellAge = ({ user }: IHasUser) => (
  <TableCell className='py-1 pe-0 w-0 text-muted-foreground/65 text-sm whitespace-nowrap'>
    {
      user.birthdate
        ? <>
          {getAge(user.birthdate)} ans
        </>
        : <TableCellEmpty text='Non défini' />
    }

  </TableCell>
);

export default DataTableBodyCellAge;
